import React from 'react';
import { FacebookIcon, InstagramIcon, TwitterIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2D2D2D] text-white" data-id="element-29">
      <div className="max-w-7xl mx-auto px-6 py-10" data-id="element-30">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-31">
          {/* Logo & Description */}
          <div className="space-y-6" data-id="element-32">
            <div className="flex flex-col items-start" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/cftwjMdZDCJ9X67HQPACwV/ChatGPT_Image_May_21,_2026,_07_24_32_PM.png" alt="NK Home Improvement Logo" className="h-24 w-auto object-contain brightness-0 invert" data-id="element-34" />
            </div>
            <p className="text-white/80 leading-relaxed text-sm" data-id="element-35">
              Premium cabinetry and flooring for residential and commercial
              spaces. Quality craftsmanship designed to last.
            </p>
          </div>

          {/* Subscribe Now */}
          <div className="space-y-8" data-id="element-36">
            <h4 className="text-xl font-bold" data-id="element-37">Subscribe Now</h4>
            <div className="space-y-4" data-id="element-38">
              <input type="text" placeholder="Enter Your Name" className="w-full bg-white text-charcoal px-4 py-3 text-sm italic outline-none" data-id="element-39" />
              <input type="email" placeholder="Enter Your Email" className="w-full bg-white text-charcoal px-4 py-3 text-sm italic outline-none" data-id="element-40" />
              <button className="bg-[#6B0D24] hover:bg-[#5A0B1E] text-white px-8 py-3 font-bold transition-colors" data-id="element-41">
                Subscribe
              </button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-8" data-id="element-42">
            <h4 className="text-xl font-bold" data-id="element-43">Contact Info</h4>
            <ul className="space-y-4 text-white/80" data-id="element-44">
              <li className="flex items-center gap-3" data-id="element-45">
                <PhoneIcon className="w-4 h-4" data-id="element-46" />
                <a href="tel:4107776984" className="hover:text-white transition-colors" data-id="element-47">
                  410-777-6984
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-48">
                <MailIcon className="w-4 h-4" data-id="element-49" />
                <a href="mailto:nkrefacers@gmail.com" className="hover:text-white transition-colors" data-id="element-50">
                  nkrefacers@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-51">
                <MapPinIcon className="w-4 h-4" data-id="element-52" />
                <span data-id="element-53">12810 7 st Bowie MD 20720</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="bg-[#252525] py-4 px-6 border-t border-white/5" data-id="element-54">
        <div className="max-w-7xl mx-auto text-center text-sm text-white/60" data-id="element-55">
          <p data-id="element-56">
            © 2018-2026{' '}
            <span className="font-bold text-white" data-id="element-57">
              NK Home Improvement LLC
            </span>{' '}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>;
}